<template>
  <div ref="cell" class="grid-view__cell"></div>
</template>

<script>
export default {
  name: 'FunctionalGridViewFieldBlank',
}
</script>
